(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bcj-shown'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function countUp(el) {
    var end = +el.getAttribute('data-count'), t0 = null, dur = 1400;
    if (reduce || isNaN(end)) { el.textContent = el.getAttribute('data-count'); return; }
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }

  function initReveal(root) {
    $$('[data-reveal]', root).forEach(function (el) { if (io) io.observe(el); else el.classList.add('bcj-shown'); });
  }

  function initHero(root) {
    $$('[data-rise]', root).forEach(function (el, i) { el.style.transitionDelay = (0.08 + i * 0.09) + 's'; });
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('bcj-is-in'); }); });
    setTimeout(function () { $$('[data-count]', root).forEach(countUp); }, 600);
    var phone = root.querySelector('[data-tilt]'), hero = root.querySelector('.bcj-hero');
    if (phone && hero && !reduce && window.matchMedia('(pointer: fine)').matches) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        phone.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 10) + 'deg)';
      });
      hero.addEventListener('pointerleave', function () { phone.style.transform = ''; });
    }
  }

  function initBurn(root) {
    var burn = root.querySelector('.bcj-burn'), how = root.querySelector('.bcj-how');
    if (!burn || !how || reduce) return;
    var ticking = false;
    var update = function () {
      var r = how.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.max(0, Math.min(1, (vh - r.top) / (r.height + vh * 0.4)));
      burn.style.setProperty('--p', p.toFixed(3)); ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initTry(root) {
    var wrap = root.querySelector('.bcj-try'); if (!wrap) return;
    var APP = (wrap.getAttribute('data-app') || 'https://bravo-cigar-journal.pplx.app').replace(/\/$/, '');
    var q = function (s) { return wrap.querySelector(s); };
    var cardImg = q('[data-card-img]'), save = q('[data-card-save]'), stamp = q('[data-card-stamp]');
    var first = q('.bcj-cigar-pick [role="radio"]');
    var state = { rating: 5 };
    function renderStars() {
      $$('.bcj-stars button', wrap).forEach(function (b) {
        var n = +b.getAttribute('data-star');
        b.classList.toggle('on', n <= state.rating);
        b.setAttribute('aria-checked', n === state.rating ? 'true' : 'false');
      });
      var s = ''; for (var i = 1; i <= 5; i++) s += i <= state.rating ? '★' : '<i>★</i>';
      var st = q('[data-card-stars]'); st.innerHTML = s; st.setAttribute('aria-label', state.rating + ' out of 5 stars');
    }
    function renderNotes() {
      var ul = q('[data-card-notes]'); ul.innerHTML = '';
      $$('.bcj-notes [aria-pressed="true"]', wrap).forEach(function (b) { var li = document.createElement('li'); li.textContent = b.textContent; ul.appendChild(li); });
    }
    function bumpStamp() { stamp.classList.remove('stamp'); void stamp.offsetWidth; stamp.classList.add('stamp'); }
    function pick(b, animate) {
      $$('.bcj-cigar-pick [role="radio"]', wrap).forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
      b.setAttribute('aria-checked', 'true');
      q('[data-card-name]').textContent = (b.getAttribute('data-name') || '').toUpperCase();
      q('[data-card-wrapper]').textContent = b.getAttribute('data-wrapper') || '';
      var src = b.getAttribute('data-img');
      if (src && cardImg) {
        if (animate && !reduce) { cardImg.classList.add('swap'); setTimeout(function () { cardImg.onload = function () { cardImg.classList.remove('swap'); }; cardImg.src = src; }, 200); }
        else cardImg.src = src;
      }
      save.href = APP + '/#/new/' + b.getAttribute('data-cigar');
      if (animate) bumpStamp();
    }
    $$('.bcj-cigar-pick [role="radio"]', wrap).forEach(function (b) { b.addEventListener('click', function () { pick(b, true); }); });
    $$('.bcj-stars button', wrap).forEach(function (b) {
      b.addEventListener('click', function () { state.rating = +b.getAttribute('data-star'); renderStars(); b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); });
    });
    $$('.bcj-seg', wrap).forEach(function (seg) {
      var out = q('[data-card-' + seg.getAttribute('data-seg') + ']');
      $$('button', seg).forEach(function (b) {
        b.addEventListener('click', function () { $$('button', seg).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); if (out) out.textContent = b.textContent; });
      });
    });
    $$('.bcj-notes button', wrap).forEach(function (b, i) {
      if (!b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', (i === 0 || i === 2) ? 'true' : 'false');
      b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); renderNotes(); });
    });
    if (first) pick(first, false);
    renderStars(); renderNotes();
  }

  function initTabs(root) {
    var bar = root.querySelector('.bcj-tabs__bar'); if (!bar) return;
    $$('[role="tab"]', bar).forEach(function (t, i) {
      t.addEventListener('click', function () {
        $$('[role="tab"]', bar).forEach(function (x) { x.setAttribute('aria-selected', 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = true; });
        t.setAttribute('aria-selected', 'true');
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = false;
        bar.classList.toggle('android', i === 1);
      });
    });
  }

  function init(root) {
    if (!root || root.__bcj) return; root.__bcj = true;
    initReveal(root);
    if (root.querySelector('.bcj-hero')) initHero(root);
    initBurn(root); initTry(root); initTabs(root);
  }

  function boot() { $$('.bcj').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.bcj'); if (r) { init(r); if (window.Shopify && window.Shopify.designMode) $$('[data-reveal]', r).forEach(function (el) { el.classList.add('bcj-shown'); }); } });
})();
